// extracted by mini-css-extract-plugin
export var textInput = "_km-0";